import React from "react";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/reset.css";
import "./style.css";
import "./table.css";
import App from "./App";
import "./i18n/i18n-config";
import { Provider } from "react-redux";
import store from "./redux/createStore";
import { createRoot } from "react-dom/client";
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
      }}
    >
      <App />
    </BrowserRouter>
  </Provider>
);
